/**
 * @desc 修改年度销售计划详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/sale/year/update',
    data,
  });
}

export function mock(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/sale/year/update',
    data,
  });
}
